<div class="row mb-4">
  <div class="bottom-table-head">
    <h4>Vendor Details</h4>
    <p-button
      label="Add Vendor"
      (click)="vendorSidebarVisible = true; VendorAddEditText = 'Add'"
      *appHasRole="[2, 3]"
    />
  </div>

  <div class="justify-content-start flex-wrap mt-15">
    <p-table [value]="VendorsDetails" class="tab-data-table">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Vendor">
            Vendor Name <p-sortIcon field="Vendor" />
          </th>
          <th pSortableColumn="Contractor">
            Contractor Name <p-sortIcon field="Contractor" />
          </th>

          <th pSortableColumn="Phone">Phone <p-sortIcon field="Phone" /></th>
          <th pSortableColumn="Address">
            Address <p-sortIcon field="Address" />
          </th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-VendorsDetails>
        <tr>
          <td>{{ VendorsDetails.contractorName }}</td>
          <td>{{ VendorsDetails.name }}</td>
          <td>{{ VendorsDetails.phone }}</td>
          <td>{{ VendorsDetails.address }}</td>
          <td>

            <div class="d-flex gap-3 action-btns">
              <img src="assets/images/icon-edit.svg" (click)="onEditVendors(VendorsDetails)" *appHasRole="[3]">
              <img src="assets/images/icon-delete.svg" (click)="onDelete(VendorsDetails.id)" *appHasRole="[3]">
            </div>


            
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="vendorSidebarVisible"
  position="right"
  [showCloseIcon]="false"
>
  <form
    [formGroup]="VendorForm"
    *ngIf="vendorSidebarVisible"
    (ngSubmit)="updateVendor()"
  >
    <div class="tab-pop-txt">
      <h4>{{ VendorAddEditText }} Vendor</h4>
      <i class="pi pi-times" (click)="vendorSidebarVisible = false"></i>
    </div>

    <div class="pop-data-set">
      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Vendor Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="VendorName"
            formControlName="VendorName"
            aria-describedby="VendorName"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Contractor Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="VendorContractorName"
            aria-describedby="VendorContractorName"
            formControlName="VendorContractorName"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Mobile</div>
        <div class="project-detail-set-v mt-2">
          <p-inputNumber
            id="Mobile"
            mode="decimal"
            id="VendorMobile"
            aria-describedby="VendorMobile"
            formControlName="VendorMobile"
            inputId="VendorMobile"
            [useGrouping]="false"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Address</div>
        <div class="project-detail-set-v mt-2">
          <textarea
            pInputTextarea
            id="VendorAddress"
            aria-describedby="VendorAddress"
            formControlName="VendorAddress"
            rows="5"
            cols="30"
            id="Address"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="tab-footer-btns">
      <p-button
        label="Cancel "
        (click)="vendorSidebarVisible = false"
        class="cancel-btn"
      />
      <p-button
        [label]="VendorAddEditText"
        type="submit"
        class="submit-btn"
        [disabled]="!VendorForm.valid"
      />
    </div>
  </form>
</p-sidebar>
